import React, { Component } from 'react';
import { Swipeable } from 'react-swipeable';
import down_icon from '../../../Images/Daikin_Images/image/down.png';
import loading from '../../../Images/loading2_invert_colours.gif';

export default class Refresh extends Component {
	constructor(props) {
		super(props);
		// At least pull threshold amount before refreshing
		// negative value because drag down
		this.threshold = -70;

		this.state = {
			deltaY: 0
		}
	}

	handleSwipeDown = (SwipeEventData) => {
		// delta Y is negative 
		if (SwipeEventData.deltaY < this.threshold) {
			window.location.reload()
		}

	}

	handleSwiping = (SwipeEventData) => {
		let deltaY = Math.abs(SwipeEventData.deltaY);
		if (deltaY > 100) deltaY = 100;

		if (SwipeEventData.dir == 'Down') {
			this.setState({ deltaY: deltaY })
		}
	}

	handleEndSwipe = () => {
		this.setState({ deltaY: 0 })
	}

	render() {
		let label_style = {
			position: 'absolute',
			top: -70,
			transform: 'translateY(' + this.state.deltaY + 'px)',
			transitionTimingFunction: 'ease-in-out',
			textAlign: 'center',
			width: '100%'
		}

		return (
			<div id='refresh'>
				<div style={label_style}>
					<div>
						<img src={loading} style={{ width: 25 }} />
					</div>
					<div>
						<span>Pull to refresh</span>
					</div>
					<div>
						<img src={down_icon} style={{ width: 25 }} />
					</div>
				</div>
				<Swipeable
					style={{ width: this.props.width, height: 40 }}
					onSwipedDown={this.handleSwipeDown}
					onSwiping={this.handleSwiping}
					onSwiped={this.handleEndSwipe}
				>

				</Swipeable>
			</div>
		)
	}
}